import { ref } from 'vue'
import { defineStore } from 'pinia'
import type { UpdateMode, Version } from '../types/version.types'

export const useVersionStore = defineStore('version', () => {
  const buildId = ref<number>(0)
  const buildNumber = ref<number>(0)
  const version = ref<string>(__APP_VERSION__)
  const updateMode = ref({
    isCritical: false,
    isDefault: false,
  })

  const setUpdateMode = (isDefault: boolean, isCritical: boolean): void => {
    updateMode.value.isDefault = isDefault
    updateMode.value.isCritical = isCritical
  }

  const checkUpdateMode = (buildType: UpdateMode): void => {
    switch (buildType) {
      case 'Default':
        setUpdateMode(true, false)
        return
      case 'Critical':
        setUpdateMode(false, true)
        return
      case 'Silent':
      default:
        setUpdateMode(false, false)
        return
    }
  }

  const setVersion = (newVersion: Version): void => {
    buildId.value = newVersion.buildId
    buildNumber.value = newVersion.buildNumber
    version.value = newVersion.version
  }

  const checkVersion = (newVersion: Version): void => {
    if (buildNumber.value && buildNumber.value !== newVersion.buildNumber) {
      checkUpdateMode(newVersion.buildType as UpdateMode)
    }
    setVersion(newVersion)
  }

  const fetchVersion = async (): Promise<any> => {
    try {
      const response = await fetch(`/version.json?t=${new Date().getTime()}`)
      if (response) {
        const newVersion = (await response.json()) as Version
        if (newVersion) {
          checkVersion(newVersion)
        }
      }
    } catch (error: any) {
      return error
    }
  }

  return {
    version,
    buildId,
    buildNumber,
    updateMode,
    fetchVersion,
  }
})
